import React, { useState, useEffect } from 'react';
import LoginPage from "./Login";
import HomePage from "./HomePage";
import ProtectedRoute from "./ProtectedRoute";
import {TailSpin} from 'react-loader-spinner';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from "react-router-dom";

const dataJsonPath = process.env.REACT_APP_DATA_JSON_PATH;


const App = () => {
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(true);
	useEffect(() => {
		fetch(`${dataJsonPath}?r=${Math.random()}`)
		.then(response => {
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			return response.json();
		})
		.then(data => {
			setData(data);
		})
		.catch(error => {
			console.error('There was a problem with the fetch operation:', error);
		})
		.finally(() => {
			console.log('Fetch data completed.');
			setLoading(false);
		});
	}, []);
    
	if (loading) {
		return <div className="spinner-container">
					< TailSpin
					  type="Puff"
					  color="#00BFFF"
					  height={100}
					  width={100}/>
				</div>
	}

	if (!data) {
		return  <div className="spinner-container">
					<span>"No data available."</span>
				</div>
	}
	
	return (
        <div className="App">
			<Router>
				<Routes>
					<Route path="/login" element={<LoginPage />} />
					<Route path="/viewer" element={
						<ProtectedRoute>
							<HomePage data={data} />
						</ProtectedRoute>
					}/>
					<Route exact path="/" element={<Navigate exact from="/" to="/viewer" replace/>} />
					<Route path="*" element={<Navigate to="/viewer" replace/>} />
				</Routes>
			</Router>
        </div>
		
    );
};

export default App;
